import React, { Component } from "react";
import style from "./SendPayment.module.css";
//import DatePicker from "react-datepicker";
import { DatePicker } from "antd";
import moment from "moment";
import { Button } from "reactstrap";
import AdHocPaymentProof from "../AdHocPaymentProof/AdHocPaymentProof";
import api from "../../../utils/Api";
import ttmLoader from "../../../assets/images/ttm-loader.gif";
import { fetchDropdownList, fetchpatient, fetchSupplier } from "../../../redux";
import { connect } from "react-redux";
import { Select } from "antd";
import {
  checkIfPermitted,
  Permissions,
} from "../../../services/RolePermissionService";
import { isValEmpty } from "../../../utils/CommonUtil";
const { Option } = Select;

export class SendPayment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      payment_type: "adhoc",
      payment_for: "1",
      isInventory: false,
      patient_id: "",
      patient_name: "",
      supplier_id: "",
      supplier_name: "",
      //name: "",
      payer_email: "",
      adh_payer_name: "",
      // adh_payer_account_name: "",
      adh_payer_bank: "",
      adh_payer_accType: "",
      adh_payee_name: "",
      //adh_payee_account_name: "",
      adh_payee_bank: "",
      // adh_payee_accType: "",
      adh_payee_account_number: "",
      adh_payment_amount: "",
      adh_payment_date: "",
      adh_payment_status: "",
      adh_client_ref: "",
      adh_internal_ref: "",
      frequency_recurrence: "",
      termination_date: "",
      sch_termination_date: "",
      sch_frequency: "",

      inputList: [],
      error: "",
      emailError: false,

      successMessage: "",
      errorMessage: "",
      isLoading: false,
      adh_payer_account_number: "",
      supplierDropdown: [],
      payment_mode_id: 2,
      isScreenLoaded: false,
      isUploadError: false,
      invoice_id: "",
      max_upload_proof:
        localStorage.getItem("SETTING_INFO") &&
        JSON.parse(localStorage.getItem("SETTING_INFO"))
          .max_paymentproof_upload,

      showErrors: {},
    };
  }
  componentDidMount = async () => {
    document.title = 'Make Payment - TechToMedix';
    //await this.props.fetchDropdownList();
    await this.props.fetchpatient(this.state.patient_name);
    await this.props.fetchSupplier(this.state.supplier_name);
    if(this.props.location.state &&
      this.props.location.state.patient_id &&
      this.props.location.state.practitioner_id &&
      this.props.location.state.amount &&
      this.props.location.state.isAppointmentPay=== true){
        this.setState({
          isAppointmentPay: true,
          payment_for: "1",
          patient_id: this.props.location.state.patient_id,
          adh_payment_amount: this.props.location.state.amount,
          invoice_id: this.props.location.state.invoice_id
        })
    }

    // await this.fetchSupplierDropdown();
    setTimeout(() => {
      this.setState({
        isScreenLoaded: true,
      });
    }, 500);
  };

  fetchSupplierDropdown = async () => {
    const token =
      localStorage.getItem("USER_INFO") &&
      JSON.parse(localStorage.getItem("USER_INFO")).token;

    const headers = {
      Authorization: "Bearer " + token,
    };
    try {
      const response = await api.get("relatedparty/supplier/dropdown", {
        headers: headers,
      });
     // console.log("+++++++++++++++++ supplier dropdown data", response.data);
      this.setState({ supplierDropdown: response.data.data });
    } catch (error) {}
  };

  getPaymentProof = (data) => {
   //console.log("Payment Proof : ", data);
    this.setState({
      inputList: data,
    });
  };

  getImageError = (data) => {
    console.log("Is Image Error : ", data);
    this.setState({
      isUploadError: data,
    });
  };

  // Handle input change
  handleInputChange = (event) => {
    const val = event.target.value;
    const name = event.target.name;
    this.setState({
      [name]: val,
    });
    if (name === "payer_email") {
      this.validateEmail(val);
    }
    if (name === "payment_for") {
      if (Number(val) === 2) {
        this.setState({
          isInventory: true,
          payer_email: "",
        });
      } else {
        this.setState({
          isInventory: false,
          payer_email: "",
        });
      }
    }

    if (name === "adh_payer_name" || name === "adh_payee_name" || 
    name === "adh_payer_bank"||name === "adh_payee_bank") {
      const regex = /^[a-zA-Z ]*$/;
      if (!regex.test(val)) {
        let showErrors = {...this.state.showErrors};
        showErrors[name] = "Only alphabets are allowed";
        this.setState({
          showErrors:showErrors
        })
      } else {
        let showErrors = {...this.state.showErrors};
        showErrors[name] = "";
        delete showErrors[name];
        this.setState({
          showErrors:showErrors
        })
      }
    }
    if (name === "adh_payer_account_number" ||
    name === "adh_payee_account_number"
  ) {
      const regex = /^[0-9]*$/;
      if (!regex.test(val)) {
        let showErrors = {...this.state.showErrors};
        showErrors[name] = "Only numbers are allowed";
        this.setState({
          showErrors:showErrors
        })
      } else {
        let showErrors = {...this.state.showErrors};
        showErrors[name] = "";
        delete showErrors[name];
        this.setState({
          showErrors:showErrors
        })
      }
    }
    if(name === "adh_payment_amount" ){
      const regex = /^[0-9]\d{0,9}(\.\d{1,2})?%?$/;
      if (!regex.test(val)) {
        let showErrors = {...this.state.showErrors};
        showErrors[name] = "Enter only numbers valid upto two decimals.";
        this.setState({
          showErrors:showErrors
        })
      } else {
        let showErrors = {...this.state.showErrors};
        showErrors[name] = "";
        delete showErrors[name];
        this.setState({
          showErrors:showErrors
        })
      }
    }
   // console.log("******** ShowErrors *********", this.state.showErrors);
  };


  //email validation
  validateEmail = (email) => {
    const pattern = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    const result = pattern.test(email);
    if (result === true) {
      this.setState({
        emailError: false,
      });
    } else {
      this.setState({
        emailError: true,
      });
    }
  };

  // validateCharsOnlyPFromName = (value, name) => {
  //   const regex = /^[a-zA-Z ]*$/;
  //   if (!regex.test(value)) {
  //     this.setState({
  //       [name]: "Enter alphabets only",
  //     });
  //   } else {
  //     this.setState({
  //       isPFromNamellowed: "",
  //     });
  //   }
  // };

  handleChangePaymentDate = (date) => {
    this.setState({
      adh_payment_date: date,
    });
  };

  handleChangeTermDate = (date) => {
    this.setState({
      sch_termination_date: date,
    });
  };

  // handleBlurChange = () => {
  //   if (
  //     //this.state.name !== "" &&
  //     (this.state.payment_for !== "" ||
  //    (this.state.payment_for == "1" &&
  //    this.state.patient_id !== "") ||
  //    (this.state.payment_for == "2" &&
  //    this.state.supplier_id !== "")) &&
  //     this.state.adh_payer_name !== "" &&
  //     this.state.payer_email !== "" &&
  //     // this.state.adh_payer_account_name !== "" &&
  //     (this.state.payment_mode_id !== "" ||
  //       (parseInt(this.state.payment_mode_id) === 2 &&
  //         this.state.adh_payer_bank !== "" &&
  //         this.state.adh_payer_accType !== "" &&
  //         this.state.adh_payer_account_number !== "" &&
  //         this.state.adh_payee_name !== "" &&
  //         this.state.adh_payee_account_number !== "" &&
  //         this.state.adh_payee_bank !== "")) &&
  //     // this.state.adh_payee_accType !== "" &&
  //     //this.state.adh_payee_account_name !== "" &&
  //     this.state.adh_payment_amount !== "" &&
  //     this.state.adh_payment_date !== "" &&
  //     this.state.adh_payment_status !== ""
  //   ) {
  //     this.setState({
  //       error: "",
  //     });
  //   } else if (
  //     this.state.payment_type === "scheduled" &&
  //     this.state.sch_frequency != "" &&
  //     this.state.sch_termination_date != ""
  //   ) {
  //     this.setState({
  //       error: "",
  //     });
  //   } else {
  //     this.setState({
  //       error: "Please filled out all mandatory fields",
  //     });
  //   }
  // };

  handleOptionChange = (event) => {
    this.resetForm();
    this.setState({
      payment_type: event.target.value,
      payment_for: "2",
    });
  };

  onChangePatient = (value) => {
    //console.log(`selected ${value}`);
    this.setState({
      patient_id: value,
    });
  };

  handleOnChangePatient = async (value, event) => {
    const emailVal =
      this.props.patientData &&
      this.props.patientData.patient &&
      this.props.patientData.patient.find((element, index) => {
        return element.patient_id === value;
      });
    this.setState({
      patient_name: emailVal && emailVal.patient_name ? emailVal.patient_name : "",
      payer_email: emailVal && emailVal.email ? emailVal.email : "",
    });
  };
  onChangeSupplier = (value) => {
    //console.log(`selected ${value}`);
    this.setState({
      supplier_id: value,
    });
  };
  handleOnChangeSupplier = async (value, event) => {
    const emailVal =
      this.props.supplierData &&
      this.props.supplierData.supplier &&
      this.props.supplierData.supplier.find((element, index) => {
        return element.supplier_id === value;
      });
    this.setState({
      supplier_name: emailVal && emailVal.supplier_name ? emailVal.supplier_name : "",
      payer_email: emailVal && emailVal.email ? emailVal.email : "" ,
    });
  };

  // Form resetting
  resetForm = () => {
    this.myFormRef.reset();
    this.setState({
      error: "",
    });
  };

  onSubmit = () => {
    if (
      // this.state.name == "" ||
      isValEmpty(this.state.payment_for) ||
      (Number(this.state.payment_for) === 1 && isValEmpty(this.state.patient_id)) ||
      (Number(this.state.payment_for) === 2 && isValEmpty(this.state.supplier_id)) ||
      isValEmpty(this.state.adh_payer_name) ||
     // this.state.payer_email == "" ||
      // this.state.adh_payer_account_name == "" ||
      isValEmpty(this.state.payment_mode_id) ||
      (Number(this.state.payment_mode_id) === 2 &&
        (isValEmpty(this.state.adh_payer_bank)||
        isValEmpty(this.state.adh_payer_accType) ||
        isValEmpty(this.state.adh_payer_account_number) ||
        isValEmpty(this.state.adh_payee_name) ||
        isValEmpty(this.state.adh_payee_account_number) ||
          // this.state.adh_payee_account_name == "" ||
          isValEmpty(this.state.adh_payee_bank))) ||
      // this.state.adh_payee_accType == "" ||
      isValEmpty(this.state.adh_payment_amount) ||
      isValEmpty(this.state.adh_payment_date) ||
      isValEmpty( this.state.adh_payment_status)
    ) {
      this.setState({
        error: "Please filled out all mandatory fields",
      });
      return false;
    }
    if (
      this.state.payment_type === "scheduled" &&
      (isValEmpty(this.state.sch_frequency ) || isValEmpty(this.state.sch_termination_date))
    ) {
      this.setState({
        error: "Please filled out all mandatory fields",
      });
      return false;
    } else {
      this.setState({
        error: "",
      });

      if (
        this.state.emailError === false &&
        Object.keys(this.state.showErrors).length === 0
      ) {
        // Calling api post request
        this.onSubmitPayment();
      }
    }
  };

  onSubmitPayment = async () => {
    this.setState({
      isLoading: true,
    });
    const formData = new FormData();
    //formData.append("name", this.state.name);
    formData.append("payer_name", this.state.adh_payer_name);
    formData.append("payer_email", this.state.payer_email);
    formData.append("payment_mode_id", this.state.payment_mode_id);
    formData.append("paymentForType", this.state.payment_for);

    if (Number(this.state.payment_for) === 1) {
      formData.append("patient_id", this.state.patient_id);
    } else {
      if (!isValEmpty(this.state.supplier_id)) {
        formData.append("supplier_id", this.state.supplier_id);
      }
    }
    if (Number(this.state.payment_mode_id) === 2) {
      // formData.append("payer_account_name", this.state.adh_payer_account_name);
      formData.append("payer_bank_name", this.state.adh_payer_bank);
      formData.append("lk_account_type_id", this.state.adh_payer_accType);

      formData.append("payee_name", this.state.adh_payee_name);
      // formData.append("payee_account_name", this.state.adh_payee_account_name);
      formData.append("payee_bank_name", this.state.adh_payee_bank);
      //formData.append("payee_accType", this.state.adh_payee_accType);
      formData.append(
        "payer_account_number",
        this.state.adh_payer_account_number
      );
      formData.append(
        "payee_account_number",
        this.state.adh_payee_account_number
      );
    }

    formData.append("payment_amount", this.state.adh_payment_amount);
    formData.append(
      "date_of_payment",
      moment(this.state.adh_payment_date).format("YYYY-MM-DD")
    );
    formData.append("payment_status_id", this.state.adh_payment_status);
    formData.append("payment_type", this.state.payment_type);
    if (!isValEmpty(this.state.adh_client_ref)) {
      formData.append("client_reference", this.state.adh_client_ref);
    }
    if (!isValEmpty(this.state.adh_internal_ref)) {
      formData.append("internal_reference", this.state.adh_internal_ref);
    }

    this.state.inputList.forEach((element, index) => {
      formData.append("attachment", element.selectedFile);
      formData.append("description", element.description);
    });

    if (this.state.payment_type === "scheduled") {
      formData.append("frequency_recurrence", this.state.sch_frequency);
      formData.append(
        "termination_date",
        moment(this.state.sch_termination_date).format("YYYY-MM-DD")
      );
    }

     if(this.state.invoice_id){
      formData.append("invoice_id", this.state.invoice_id);
    }

    // Headers
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    try {
      const response = await api.post("payment/sentpayment/save", formData, {
        headers: headers,
      });
      if (response.status === 200) {
        this.setState({
          isLoading: false,
          successMessage: "Payment added successfully!",
        });
      }
      setTimeout(() => {
        this.setState({
          successMessage: "",
        });
        if (checkIfPermitted(Permissions.VIEW_PAYMENT_TRANSACTION)) {
          this.props.history.push({
            pathname: "/app/paymenthistory",
          });
        }
      }, 2000);
    } catch (error) {
      if (error.response) {
        this.setState({
          isLoading: false,
          errorMessage: "Internal server error occured",
        });
        setTimeout(() => {
          this.setState({
            errorMessage: "",
          });
        }, 2000);
      }
      console.log("Add payment error", error);
    }
  };

  render() {
    const dropdownData = this.props.dropdownListData.dropdownList;
    const accTypeOptions =
      dropdownData &&
      dropdownData.lk_account_type &&
      dropdownData.lk_account_type.map((element, index) => (
        <option key={index} value={element.lk_account_type_id}>
          {element.account_type}
        </option>
      ));

    const patientOptions =
      this.props.patientData && this.props.patientData.patient;

    const supplierOptions =
      this.props.supplierData && this.props.supplierData.supplier;

    const paymentTypeOptions =
      dropdownData &&
      dropdownData.payment_mode &&
      dropdownData.payment_mode.map((element, index) => (
        <option key={index} value={element.payment_mode_id}>
          {element.payment_mode}
        </option>
      ));

    if (!this.state.isScreenLoaded) {
      return (
        <div className="dashboard-loader">
          <img src={ttmLoader} alt="loader" className="loader-image" />
        </div>
      );
    }

    return (
      <div className={style.receivePaymentMainWrapper}>
        <div className="row">
          <div className="col-md-12">
            <h3>Make Payment</h3>
          </div>
          <div className="col-lg-12 intro-text">
            <p className="mb-4">
            Payments made by the practice to any external parties such as Suppliers or Service Providers must be 
            captured using this form. The Make Payment feature is used to capture outward bound payments. 
            These payments may either be once-off (Ad-hoc) or repeated (Scheduled). 
            The Proof of Payment may be uploaded if needed.
            </p>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-lg-12">
            <label className="mb-2">Payment Type :</label>
            <div>
              <div className="custom-control custom-radio custom-control-inline">
                <input
                  type="radio"
                  className="custom-control-input"
                  id="adhoc"
                  name="payment_type"
                  value="adhoc"
                  checked={this.state.payment_type === "adhoc"}
                  onChange={this.handleOptionChange}
                />
                <label className="custom-control-label" htmlFor="adhoc">
                  Ad-hoc Payment
                </label>
              </div>
              <div className="custom-control custom-radio custom-control-inline">
                <input
                  type="radio"
                  className="custom-control-input"
                  id="scheduled"
                  name="payment_type"
                  value="scheduled"
                  checked={this.state.payment_type === "scheduled"}
                  onChange={this.handleOptionChange}
                />
                <label className="custom-control-label" htmlFor="scheduled">
                  Scheduled Payment
                </label>
              </div>
            </div>
          </div>
        </div>

        <form
          className={style.createRPaymentrapper}
          ref={(el) => (this.myFormRef = el)}
        >
          {/* //////// Adhoc payment wrapper start ///////// */}

          <div className={style.adHocPaymentWrapper}>
            <div className="form-box-shadow mb-4">
              <div className="row">
                <div className="col-lg-12">
                  {this.state.payment_type === "adhoc" && (
                    <h4>Ad-Hoc Payment Details</h4>
                  )}
                  {this.state.payment_type === "scheduled" && (
                    <h4>Scheduled Payment Details</h4>
                  )}
                </div>
              </div>
              {/* {this.state.payment_type === "scheduled" && ( */}

              {this.state.payment_type === "adhoc" && (
                <div className="row">
                  <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                    <div className="form-group">
                      <div>
                        <label htmlFor="payment_for">
                          Payment For:{" "}
                          <span className="mandatory">
                            <small>*</small>
                          </span>
                        </label>
                        <select
                          className="form-control"
                          id="payment_for"
                          name="payment_for"
                          disabled={this.state.isAppointmentPay}
                          onChange={this.handleInputChange}
                          value={this.state.payment_for}
                        >
                          <option value="">Select payment for</option>
                          <option value="1">Appointment</option>
                          <option value="2">Inventory</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="row">
                {/* <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                  <div className="form-group">
                    <label htmlFor="sch_name"> Name</label>
                    <input
                      type="text"
                      className="form-control"
                      id="sch_name"
                      name="name"
                      placeholder="Name"
                      onChange={this.handleInputChange}
                      onBlur={this.handleBlurChange}
                    />
                  </div>
                </div> */}
                {Number(this.state.payment_for) === 1 &&
                  this.state.payment_type === "adhoc" && (
                    <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                      <div className="form-group">
                        <label>
                          Patient Name{" "}
                          <span className="mandatory">
                            <small>*</small>
                          </span>
                        </label>
                        {/* <p>*********** {JSON.stringify(this.state.patient_id)}</p> */}
                        <Select
                          showSearch
                          allowClear={true}
                          name="patient_name"
                          disabled={this.state.isAppointmentPay}
                          placeholder="Search Patient"
                          optionFilterProp="children"
                          onChange={this.onChangePatient}
                          onSearch={this.onSearchPatient}
                          onSelect={(value, event) =>
                            this.handleOnChangePatient(value, event)
                          }
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          value={this.state.patient_id || undefined}
                        >
                          {patientOptions &&
                            patientOptions.map((element, index) => (
                              <Option key={index} value={element.patient_id}>
                                {element.patient_name}
                              </Option>
                            ))}
                        </Select>
                      </div>
                    </div>
                  )}
                {Number(this.state.payment_for) === 2 && (
                  <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="supplier_name">
                        Supplier
                        <span className="mandatory">
                          <small>*</small>
                        </span>
                      </label>
                      <Select
                        showSearch
                        allowClear={true}
                        name="supplier_name"
                        placeholder="Search supplier"
                        optionFilterProp="children"
                        onChange={this.onChangeSupplier}
                        onSearch={this.onSearchSupplier}
                        onSelect={(value, event) =>
                          this.handleOnChangeSupplier(value, event)
                        }
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        value={this.state.supplier_id}
                      >
                        {supplierOptions &&
                          supplierOptions.map((element, index) => (
                            <Option key={index} value={element.supplier_id}>
                              {element.supplier_name}
                            </Option>
                          ))}
                      </Select>
                    </div>
                  </div>
                )}
                <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                  <div className="form-group">
                    <label htmlFor="adh_payer_name">
                      Email
                    </label>
                    <input
                      type="text"
                      id="payer_email"
                      name="payer_email"
                      placeholder="Email"
                      value={this.state.payer_email}
                      onChange={this.handleInputChange}
                      className={`form-control ${
                        this.state.emailError ? "is-invalid" : ""
                      }`}
                    />
                    {this.state.emailError ? (
                      <span className="error">
                        Please Enter valid email address
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                  <div className="form-group">
                    <label htmlFor="payment_mode_id">
                      Type of Payment
                      <span className="mandatory">
                        <small>*</small>
                      </span>
                    </label>
                    <select
                      className="form-control"
                      id="payment_mode_id"
                      name="payment_mode_id"
                      onChange={this.handleInputChange}
                      value={this.state.payment_mode_id}
                    >
                      <option value="">Select type of payment</option>
                      {paymentTypeOptions}
                    </select>
                  </div>
                </div>
              </div>
              {/* )} */}

              <div className="row">
                <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                  <div className="form-group">
                    <label htmlFor="adh_payer_name">
                      Pay From - Name
                      <span className="mandatory">
                        <small>*</small>
                      </span>
                    </label>
                    <input
                      type="text"
                      id="adh_payer_name"
                      name="adh_payer_name"
                      placeholder="Payer Name"
                      maxLength="20"
                      onChange={this.handleInputChange}
                      className={`form-control ${
                        "adh_payer_name" in this.state.showErrors === false ||
                        isValEmpty(this.state.showErrors.adh_payer_name)
                          ? ""
                          : "is-invalid"
                      }`}
                    />
                    {this.state.showErrors.adh_payer_name !== "" ? (
                      <p>
                        <span className="error">
                          {this.state.showErrors.adh_payer_name}
                        </span>
                      </p>
                    ) : (
                      <React.Fragment></React.Fragment>
                    )}
                  </div>
                </div>
                {/* <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                  <div className="form-group">
                    <label htmlFor="adh_payer_account_name">
                      Pay From - Account Name:
                      <span className="mandatory">
                        <small>*</small>
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="adh_payer_account_name"
                      name="adh_payer_account_name"
                      placeholder="Payer Account Name"
                      onChange={this.handleInputChange}
                      onBlur={this.handleBlurChange}
                    />
                  </div>
                </div> */}

                {parseInt(this.state.payment_mode_id) === 2 && (
                  <React.Fragment>
                    <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                      <div className="form-group">
                        <label htmlFor="adh_payer_bank">
                          Pay From - Bank Name
                          <span className="mandatory">
                            <small>*</small>
                          </span>
                        </label>
                        <input
                          type="text"
                          id="adh_payer_bank"
                          name="adh_payer_bank"
                          placeholder="Payer Bank Name"
                          maxLength="25"
                          onChange={this.handleInputChange}
                          className={`form-control ${
                            "adh_payer_bank" in this.state.showErrors === false ||
                            isValEmpty(this.state.showErrors.adh_payer_bank)
                              ? ""
                              : "is-invalid"
                          }`}
                        />
                        {this.state.showErrors.adh_payer_bank !== "" && (
                          <p>
                            <span className="error">
                              {this.state.showErrors.adh_payer_bank}
                            </span>
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                      <div className="form-group">
                        <label htmlFor="adh_payer_accType">
                          Pay From - Account Type
                          <span className="mandatory">
                            <small>*</small>
                          </span>
                        </label>
                        <select
                          className="form-control"
                          id="adh_payer_accType"
                          name="adh_payer_accType"
                          onChange={this.handleInputChange}
                        >
                          <option vale="">Select Account Type</option>
                          {accTypeOptions}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                      <div className="form-group">
                        <label htmlFor="account_number">
                          Pay From - Account Number:
                          <span className="mandatory">
                            <small>*</small>
                          </span>
                        </label>
                        <input
                          type="text"
                          id="adh_payer_account_number"
                          name="adh_payer_account_number"
                          placeholder="Payer Account Number"
                          maxLength="20"
                          onChange={this.handleInputChange}
                          className={`form-control ${
                            "adh_payer_account_number" in
                              this.state.showErrors ===
                              false ||
                              isValEmpty(this.state.showErrors.adh_payer_account_number)
                              ? ""
                              : "is-invalid"
                          }`}
                        />
                        {this.state.showErrors.adh_payer_account_number !==
                        "" ? (
                          <p>
                            <span className="error">
                              {this.state.showErrors.adh_payer_account_number}
                            </span>
                          </p>
                        ) : (
                          <React.Fragment></React.Fragment>
                        )}
                      </div>
                    </div>
                  </React.Fragment>
                )}
              {/* </div>

              <div className="row"> */}
                <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                  <div className="form-group">
                    <label htmlFor="adh_payee_name">
                      Pay To - Name:
                      <span className="mandatory">
                        <small>*</small>
                      </span>
                    </label>
                    <input
                      type="text"
                      name="adh_payee_name"
                      id="adh_payee_name"
                      placeholder="Payee Name"
                      maxLength="20"
                      onChange={this.handleInputChange}
                      className={`form-control ${
                        "adh_payee_name" in this.state.showErrors === false ||
                        isValEmpty(this.state.showErrors.adh_payee_name)
                          ? ""
                          : "is-invalid"
                      }`}
                    />
                    {this.state.showErrors.adh_payee_name !== "" ? (
                      <p>
                        <span className="error">
                          {this.state.showErrors.adh_payee_name}
                        </span>
                      </p>
                    ) : (
                      <React.Fragment></React.Fragment>
                    )}
                  </div>
                </div>
                {/* <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                  <div className="form-group">
                    <label htmlFor="adh_payee_account_name">
                      Pay To - Account Name:
                      <span className="mandatory">
                        <small>*</small>
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="adh_payee_account_name"
                      name="adh_payee_account_name"
                      placeholder="Payee Account Name"
                      onChange={this.handleInputChange}
                      onBlur={this.handleBlurChange}
                    />
                  </div>
                </div> */}
                {parseInt(this.state.payment_mode_id) === 2 && (
                  <React.Fragment>
                    <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                      <div className="form-group">
                        <label htmlFor="adh_payee_bank">
                          Pay To - Bank Name
                          <span className="mandatory">
                            <small>*</small>
                          </span>
                        </label>
                        <input
                          type="text"
                          id="adh_payee_bank"
                          name="adh_payee_bank"
                          placeholder="Payee Bank Name"
                          maxLength="25"
                          onChange={this.handleInputChange}
                          className={`form-control ${
                            "adh_payee_bank" in this.state.showErrors === false ||
                            isValEmpty(this.state.showErrors.adh_payee_bank)
                              ? ""
                              : "is-invalid"
                          }`}
                        />
                        {this.state.showErrors.adh_payee_bank !== "" && (
                          <p>
                            <span className="error">
                              {this.state.showErrors.adh_payee_bank}
                            </span>
                          </p>
                        )}
                      </div>
                    </div>

                    {/* <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                  <div className="form-group">
                    <label htmlFor="adh_payee_accType">
                      Pay To - Account Type
                      <span className="mandatory">
                        <small>*</small>
                      </span>
                    </label>
                    <select
                      className="form-control"
                      id="adh_payee_accType"
                      name="adh_payee_accType"
                      onChange={this.handleInputChange}
                      onBlur={this.handleBlurChange}
                    >
                      <option vale="">Select Account Type</option>
                      {accTypeOptions}
                    </select>
                  </div>
                </div> */}
                    <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                      <div className="form-group">
                        <label htmlFor="adh_payee_account_number">
                          Pay To - Account Number:
                          <span className="mandatory">
                            <small>*</small>
                          </span>
                        </label>
                        <input
                          type="text"
                          maxLength="20"
                          id="adh_payee_account_number"
                          name="adh_payee_account_number"
                          placeholder="Payee Account Number"
                          onChange={this.handleInputChange}
                          className={`form-control ${
                            "adh_payee_account_number" in
                              this.state.showErrors ===
                              false ||
                              isValEmpty(this.state.showErrors.adh_payee_account_number)
                              ? ""
                              : "is-invalid"
                          }`}
                        />
                        {this.state.showErrors.adh_payee_account_number !==
                        "" ? (
                          <p>
                            <span className="error">
                              {this.state.showErrors.adh_payee_account_number}
                            </span>
                          </p>
                        ) : (
                          <React.Fragment></React.Fragment>
                        )}
                      </div>
                    </div>
                  </React.Fragment>
                )}
              {/* </div>

              <div className="row"> */}
                <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                  <div className="form-group amount-input-col">
                    <label htmlFor="adh_payment_amount">
                      Payment Amount (ZAR)
                      <span className="mandatory">
                        <small>*</small>
                      </span>
                    </label>
                    <input
                      type="text"
                      id="adh_payment_amount"
                      name="adh_payment_amount"
                      placeholder="Payment Amount (ZAR)"
                      maxLength="10"
                      value={this.state.adh_payment_amount}
                      onChange={this.handleInputChange}
                      className={`form-control ${
                        "adh_payment_amount" in this.state.showErrors ===
                          false ||
                          isValEmpty(this.state.showErrors.adh_payment_amount)
                          ? ""
                          : "is-invalid"
                      }`}
                    />
                    {this.state.showErrors.adh_payment_amount !== "" ? (
                      <p>
                        <span className="error">
                          {this.state.showErrors.adh_payment_amount}
                        </span>
                      </p>
                    ) : (
                      <React.Fragment></React.Fragment>
                    )}
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                  <div className="form-group">
                    <label htmlFor="adh_payment_date">
                      Date of Payment
                      <span className="mandatory">
                        <small>*</small>
                      </span>
                    </label>

                    <DatePicker
                      selected={
                        this.state.adh_payment_date
                          ? new Date(this.state.adh_payment_date)
                          : null
                      }
                      onChange={this.handleChangePaymentDate}
                      className="form-control"
                      id="adh_payment_date"
                      name="adh_payment_date"
                      dateFormat="yyyy-MM-dd"
                      placeholderText="Date of Payment"
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                  <div className="form-group">
                    <label htmlFor="adh_payment_status">
                      Payment Status
                      <span className="mandatory">
                        <small>*</small>
                      </span>
                    </label>
                    <select
                      className="form-control"
                      id="adh_payment_status"
                      name="adh_payment_status"
                      onChange={this.handleInputChange}
                    >
                      <option vale="">Select Payment Status</option>
                      <option value="2">Completed</option>
                      <option value="1">Pending</option>
                    </select>
                  </div>
                </div>
              {/* </div>

              <div className="row"> */}
                <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                  <div className="form-group">
                    <label htmlFor="adh_client_ref">Client Reference</label>
                    <input
                      type="text"
                      className="form-control"
                      id="adh_client_ref"
                      name="adh_client_ref"
                      maxLength="20"
                      placeholder="Client Reference"
                      onChange={this.handleInputChange}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                  <div className="form-group">
                    <label htmlFor="adh_internal_ref">Internal Reference</label>
                    <input
                      type="text"
                      className="form-control"
                      id="adh_internal_ref"
                      maxLength="20"
                      name="adh_internal_ref"
                      placeholder="Internal Reference"
                      onChange={this.handleInputChange}
                    />
                  </div>
                </div>

                {this.state.payment_type === "scheduled" && (
                  <div className="col-lg-3">
                    <div className="form-group">
                      <label htmlFor="sch_frequency">
                        Frequency/Recurrence
                        <span className="mandatory">
                          <small>*</small>
                        </span>
                      </label>
                      <select
                        className="form-control"
                        id="sch_frequency"
                        name="sch_frequency"
                        onChange={this.handleInputChange}
                      >
                        <option vale="">Select Frequency/Recurrence</option>
                        <option value="1">Weekly</option>
                        <option value="2">Monthly</option>
                      </select>
                    </div>
                  </div>
                )}
              {/* </div> */}
              {this.state.payment_type === "scheduled" && (
                // <div className="row">
                  <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="sch_termination_date">
                        Termination Date
                        <span className="mandatory">
                          <small>*</small>
                        </span>
                      </label>

                      <DatePicker
                        selected={
                          this.state.sch_termination_date
                            ? new Date(this.state.sch_termination_date)
                            : null
                        }
                        onChange={this.handleChangeTermDate}
                        className="form-control"
                        id="sch_termination_date"
                        name="sch_termination_date"
                        dateFormat="yyyy-MM-dd"
                        placeholderText="Termination Date"
                      />
                    </div>
                  </div>
              )}
              </div>
            </div>

            {this.state.max_upload_proof !== 0 && (
              <div className="form-box-shadow mb-4">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="mb-3">
                      <h4 className={style.proofHeading}>
                        Upload Proof of Payment
                      </h4>
                      <small>
                        {`Upload up to ${this.state.max_upload_proof} Proofs of Payment. The allowed extensions are pdf, jpg, png, svg. Maximum size limit is 2MB.`}
                      </small>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <AdHocPaymentProof
                      getPaymentProof={this.getPaymentProof}
                      getImageError={this.getImageError}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* //////// Adhoc payment wrapper end ///////// */}

          {/*  Show validation message */}
          {this.state.error && (
            <div className="row">
              <div className="col-lg-12">
                <p className={`error ${style.errorText}`}>{this.state.error}</p>
              </div>
            </div>
          )}

          <div className="row">
            <div className="col-md-12">
              {this.state.isLoading ? (
                <div className={style.loadingWrapper}>
                  <img src={ttmLoader} alt="loader" className={style.loading} />
                </div>
              ) : (
                <div>
                  {this.state.successMessage && (
                    <p className={style.successMessage}>
                      {this.state.successMessage}
                    </p>
                  )}
                  {this.state.errorMessage && (
                    <p className={style.errorMessage}>
                      {this.state.errorMessage}
                    </p>
                  )}
                </div>
              )}
            </div>
          </div>

          <div className="row">
            <div
              className={`col-lg-12 d-flex justify-content-center justify-content-sm-end ${style.receivePaymentBtnWrapper}`}
            >
              <Button className="form-primary-btn mb-3" onClick={this.onSubmit}>
                Add Payment
              </Button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dropdownListData: state.dropdownList,
    patientData: state.patient,
    supplierData: state.supplier,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDropdownList: () => dispatch(fetchDropdownList()),
    fetchpatient: (patientName) => dispatch(fetchpatient(patientName)),
    fetchSupplier: (supplier_name) => dispatch(fetchSupplier(supplier_name)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SendPayment);
